export default ['$timeout', ($timeout) => {
    const basketPopup = {};
    basketPopup.item = undefined;
    basketPopup.guests = [];
    basketPopup.show = false;

    basketPopup.success = (item, guests, expiresAt) => {
        $timeout.cancel(basketPopup.fadeTimer);
        basketPopup.alerttype = 'alert--success';
        basketPopup.guests = guests;
        basketPopup.item = item;
        basketPopup.expiresAt = expiresAt;
        basketPopup.show = true;
    };

    basketPopup.failure = (item) => {
        $timeout.cancel(basketPopup.fadeTimer);
        basketPopup.alerttype = 'alert--fail';
        basketPopup.item = item;
        basketPopup.show = true;
    };

    basketPopup.remove = () => {
        basketPopup.show = false;

        basketPopup.fadeTimer = $timeout(() => {
            basketPopup.item = undefined;
            basketPopup.expiresAt = undefined;
        }, 500);
    };

    return basketPopup;
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/popup/services/basket.popup.service.js